// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"209":"worldcup","813":"mission"}[chunkId] + "." + {"209":"6b4044ab","813":"bb8f04d5"}[chunkId] + ".css";
};